import React from 'react';
import { Card, Alert } from 'react-bootstrap';
import FileUploadDemo from './shared/FileUploadDemo';

const RiberaStep5 = ({ formData, onChange }) => {
    const handleFileChange = (name, file) => {
        onChange({ ...formData, [name]: file });
    };

    return (
        <Card className="shadow-sm">
            <Card.Header className="bg-primary text-white">
                <h5 className="mb-0">Paso 5: Comprobante de Pago</h5>
            </Card.Header>
            <Card.Body>
                <FileUploadDemo
                    label="Comprobante de Pago Formulario F924"
                    name="comprobantePago"
                    accept=".pdf,.jpg,.jpeg,.png"
                    file={formData.comprobantePago}
                    onChange={handleFileChange}
                    required={true}
                />

                <Alert variant="info" className="mt-4">
                    <h6>Información sobre el Pago</h6>
                    <p className="mb-2">
                        <strong>Formulario:</strong> F924 - Línea de Ribera
                    </p>
                    <p className="mb-2">
                        <strong>Formatos aceptados:</strong> PDF, JPG, PNG
                    </p>
                    <p className="mb-0">
                        <strong>Nota:</strong> El comprobante debe ser legible y mostrar claramente
                        el número de formulario, fecha de pago y monto abonado.
                    </p>
                </Alert>

                <Alert variant="secondary" className="mt-3">
                    <small>
                        <strong>Recordatorio:</strong> Conserve el comprobante original. Este documento
                        será verificado durante el procesamiento del trámite.
                    </small>
                </Alert>
            </Card.Body>
        </Card>
    );
};

export default RiberaStep5;
